export const MasterCategoryFormValidations = {
  name: [{ type: 'required', message: 'This field is required' }],
  code: [{ type: 'required', message: 'This field is required' }],
  active: [{ type: 'required', message: 'This field is required' }],
};
